import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";

const LGAForm = (props) => {
  const [lga, setLga] = useState("");
  const [lgaData, setLgaData] = useState([]);
  const [stateId, setStateId] = useState();
  const [stateData, setStatedata] = useState([]);

  const { sendRequest: getLgaData } = useHttp();

  const { sendRequest: postLGADetails } = useHttp();

  const FillDetail = () => {
    getLgaData(
      { 
        url: `/api/lgaLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setLgaData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getLgaData]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setStatedata(data);
      }
    );
  }, [getStateData]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (!props.update) {
      const isExistingLga = lgaData.some(
        (lgaName) => lgaName.lga === lga
      );

      if (isExistingLga) {
        toast.error("LGA already exist");
        return;
      }
    }
    const data = [{
      ...(props.update && { lgaId: props.update.lgaId }), 
      stateId: stateId,
      lga: lga.trim(),
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,
    }];

    console.log("data", data);

    // if(props.update) {
    //     data[0].lgaId = props.update.lgaId;
    // }

    postLGADetails(
      {
        url: "/api/lgaLocation/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (res) => {
        toast.success(
          `LGA Detail ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      },
      (error) => {
        toast.error(error || "Something went wrong");
        console.log(error);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
      setStateId(props.update.stateId);
      setLga(props.update.lga);
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">LGA</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>State Name</label>
                        <select
                          id="stateId"
                          className="form-control"
                          required
                          value={stateId}
                          onChange={(e) => {
                            setStateId(e.target.value);
                          }}
                        >
                          <option value="">Select State</option>
                          {stateData &&
                            stateData.map((x) => (
                              <option key={x.stateId} value={x.stateId}>
                                {x.stateName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>LGA</label>
                        <input
                          type={"text"}
                          id={"lga"}
                          required
                          className="form-control"
                          value={lga}
                          onChange={(e) => {
                            setLga(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default LGAForm;
